var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.dataForm.id ? 'Edit Config' : 'Add Config',
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "width": "1000px",
      "top": "1vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "country"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    on: {
      "change": _vm.onCountryChange
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.nativeCountryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Business Type",
      "prop": "businessType"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "placeholder": "Select country first"
    },
    model: {
      value: _vm.dataForm.businessType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "businessType", $$v);
      },
      expression: "dataForm.businessType"
    }
  }, _vm._l(_vm.filteredBusinessTypes, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Business Specification (EN)",
      "prop": "specification"
    }
  }, [_c('el-editor', {
    attrs: {
      "height": 400
    },
    model: {
      value: _vm.dataForm.specification,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "specification", $$v);
      },
      expression: "dataForm.specification"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Business Specification (CN)",
      "prop": "specificationCn"
    }
  }, [_c('el-editor', {
    attrs: {
      "height": 400
    },
    model: {
      value: _vm.dataForm.specificationCn,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "specificationCn", $$v);
      },
      expression: "dataForm.specificationCn"
    }
  })], 1)], 1), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }